<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableApprovalTaskPassedDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="info"
          size="small"
          v-hasPermission="['approval_task:ApprovalTask:approvalDetail']"
          @click="tableApprovalTaskPassedDetail(row)"
          >{{ $t("ApprovalTask.view") }}</Button
        >
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import utils from "../../../utils/utils.js";
var tableApprovalTaskVue = {};
export default {
  name: "TableApprovalTaskPassed",
  data() {
    return {
      current: 1, //分页
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          title: "ID",
          key: "id"
        },
        {
          title: this.$t("ApprovalTask.approvalFlowName"),
          key: "approvalProcessName"
        },
        {
          title: this.$t("ApprovalTask.submitter"),
          key: "applicant"
        },
        {
          title: this.$t("ApprovalTask.category"),
          key: "type"
        },
        {
          title: this.$t("ApprovalTask.status"),
          key: "status"
        },
        {
          title: this.$t("ApprovalTask.launchTime"),
          key: "creationTime"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableApprovalTaskPassedDate: []
    };
  },
  beforeCreate: function() {
    tableApprovalTaskVue = this;
  },
  mounted: function() {
    tableApprovalTaskVue.getTableApprovalTaskData();
  },
  methods: {
    // 点击查看详情跳转
    tableApprovalTaskPassedDetail: function(row) {
      this.$router.push({
        path: "/approvalTask/approvalTaskDetail/",
        query: { id: row.id }
      });
    },
    showAll: function() {
      tableApprovalTaskVue.getTableApprovalTaskData();
    },
    // 分页显示数据
    /****************************************************/
    getTableApprovalTaskData: function() {
      // 获取ApprovalTaskSearch里面的搜索内容
      eventBus.$on("approvalNameSearchID", function(val) {
        tableApprovalTaskVue.val = val;
      });
      eventBus.$on("companyId", function(companyId) {
        tableApprovalTaskVue.companyId = companyId;
      });
      //列表分页
      this.$api.processTask
        .historyPage({
          state: 1,
          type: tableApprovalTaskVue.val,
          companyId: tableApprovalTaskVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableApprovalTaskPassedDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 时间
          for (var i = 0; i < this.tableApprovalTaskPassedDate.length; i++) {
            // 开始时间
            this.tableApprovalTaskPassedDate[
              i
            ].creationTime = utils.methods.formatDate(
              this.tableApprovalTaskPassedDate[i].creationTime
            );
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableApprovalTaskVue.getTableApprovalTaskData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableApprovalTaskVue.getTableApprovalTaskData();
    },
    // 销毁approvalNameSearchID
    beforeDestroy: function() {
      eventBus.$off("approvalNameSearchID");
      eventBus.$off("companyId");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.ivu-form-item {
  margin-bottom: 0px !important;
  vertical-align: top;
  zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/approval_task/approval_task_passed/TableApprovalTaskPassed.vue